import cx from 'classnames';
import React from 'react';
import styles from './PlusBadge.mscss';

interface OwnProps {
    className?: string;
}

type Props = OwnProps;

export const PlusBadge: React.FunctionComponent<Props> = React.memo(({
    className,
}) => (
    <span className={cx(styles.PlusBadge, className)}>PLUS</span>
));

PlusBadge.displayName = 'PlusBadge';
